import UnregisterDeviceConfirmationV2 from './UnregisterDeviceConfirmationV2';
import { Device } from '@raydiant/api-client-js';

interface UnregisterDeviceConfirmationProps {
  device: Device;
  open: boolean;
  onConfirm: ((result: boolean) => void) | null;
}

const UnregisterDeviceConfirmation = ({
  device,
  open,
  onConfirm,
}: UnregisterDeviceConfirmationProps) => {
  return (
    <>
      <UnregisterDeviceConfirmationV2
        device={device}
        open={open}
        onConfirm={onConfirm}
      />
    </>
  );
};

export default UnregisterDeviceConfirmation;
